var map = {
	"./chess.png": 527,
	"./company1.png": 373,
	"./company2.png": 960,
	"./company3.png": 652,
	"./company4.png": 214,
	"./devStop.png": 809,
	"./finwallet.png": 347,
	"./hallomeet.png": 881,
	"./hero.png": 336,
	"./netflix.png": 372,
	"./portfolios.png": 815,
	"./techchefz.png": 545,
	"./test1.png": 419,
	"./test2.png": 864,
	"./test3.png": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;